import { Injectable } from "@angular/core";

import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  NavigationExtras,
  CanLoad,
  Route,
} from "@angular/router";
import "rxjs/add/operator/toPromise";

@Injectable()
export class DashGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    // Imaginary method that is supposed to validate an auth token and return a boolean
    // if (localStorage.getItem('userName') != "eventorg") {
    //     this.router.navigate(['/dashboard']);
    //     return true;
    // } else {
    //     this.router.navigate(['/organisations/create']);
    //     return false;
    // }

    // Check userID exists or not
    if (localStorage.getItem("email") == "") {
      this.router.navigate(["/hj"]);
      return true;
    } else if (localStorage.getItem("statusCheck") != "1") {
      this.router.navigate(["/dashboard"]);
      return true;
    } else {
      this.router.navigate(["/organisations/create"]);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/services/admincheck.service.ts